import * as Yup from 'yup';

export const TripLogUpdateContactSchema = Yup.object().shape({
    contactInfo: Yup.string().required('Driver Name is required'),
});

export type TripLogUpdateContactDataType = Yup.InferType<typeof TripLogUpdateContactSchema>;

type InitialValues = {
    contactInfo: string;


};

export const TripLogUpdateContactInitialValues: InitialValues = {
    contactInfo: '',
};

export interface TripLogUpdateContactInterface {
    contactInfo: string;
}
